import { Locale } from './types';
import {
  getBaseCollator,
  getStrictCollator,
  getInsensitiveCollator,
  getNumericCollator,
  getNumericLowercaseCollator,
  getLowercaseCollator,
} from './utils';

export const localeCompare = (a: string, b: string, locale: Locale) => {
  return getStrictCollator(locale).compare(a, b);
};

export const localeCompareNumeric = (a: string, b: string, locale: Locale) => {
  return getNumericCollator(locale).compare(a, b);
};

export const localeCompareNumericLowercase = (
  a: string,
  b: string,
  locale: Locale
) => {
  return getNumericLowercaseCollator(locale).compare(a, b);
};

export const localeCompareBase = (a: string, b: string, locale: Locale) => {
  return getBaseCollator(locale).compare(a, b);
};

export const localeCompareInsensitive = (
  a: string,
  b: string,
  locale: Locale
) => {
  return getInsensitiveCollator(locale).compare(a, b);
};

export const localeAreEqualLowercase = (
  a: string,
  b: string,
  locale: Locale
) => {
  return getLowercaseCollator(locale).compare(a, b) === 0;
};

export const localeIncludesLowercase = (
  value: string,
  searchPhrase: string,
  locale: Locale
) => {
  const searchPhraseLowercase = searchPhrase.toLocaleLowerCase(locale.code);

  return value.toLocaleLowerCase(locale.code).includes(searchPhraseLowercase);
};

export const localeIndexOfLowercase = (
  value: string,
  searchPhrase: string,
  locale: Locale
) => {
  const searchPhraseLowercase = searchPhrase.toLocaleLowerCase(locale.code);

  return value.toLocaleLowerCase(locale.code).indexOf(searchPhraseLowercase);
};
